import { render, staticRenderFns } from "./BillShareDepartmentDialogtwo.vue?vue&type=template&id=3b71f08c&scoped=true&"
import script from "./BillShareDepartmentDialogtwo.vue?vue&type=script&lang=js&"
export * from "./BillShareDepartmentDialogtwo.vue?vue&type=script&lang=js&"
import style0 from "./BillShareDepartmentDialogtwo.vue?vue&type=style&index=0&id=3b71f08c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b71f08c",
  null
  
)

export default component.exports